import React, { useState, useEffect, useRef } from 'react';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { Fragment } from 'react';
import Header from 'src/components/template/layout/Header';


const Tentang = () => {
    const [connection, setConnection] = useState(null);
    const [chat, setChat] = useState([]);
    const latestChat = useRef(null);
    const [userMe, setUserMe] = useState('');
    const [userTo, setUserTo] = useState('');
    const [msg, setMsg] = useState('');

    latestChat.current = chat;

    useEffect(() => {
        const newConnection = new HubConnectionBuilder()
            .withUrl('http://localhost:5001/msg')
            .withAutomaticReconnect()
            .build();

        setConnection(newConnection);
    }, []);

    useEffect(() => {
        if (connection) {
            connection.start()
                .then(result => {
                    console.log('Connected!');
                    console.log('Connection ID : ', connection.connection.connectionId);

                    connection.on('ReceiveMessageAll', message => {
                        const updatedChat = [...latestChat.current];
                        updatedChat.push(message);
                        console.log(message)

                        setChat(updatedChat);
                    });
                    connection.on('ReceiveMessageBy', message => {
                        console.log(message)
                    });
                })
                .catch(e => console.log('Connection failed: ', e));
        }
    }, [connection]);

    const sendMessage = async () => {
        const chatMessage = {
            user: userMe,
            message: msg
        };

        if (connection.connectionStarted) {
            try {
                await fetch('http://localhost:5001/api/webs/create', {
                    method: 'POST',
                    body: JSON.stringify(chatMessage),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
            }
            catch (e) {
                console.log(e);
            }
        }
        else {
            alert('No connection to server yet.');
        }
    }

    return (
        <>
            {/* <ChatInput sendMessage={sendMessage} /> */}

            <div className="site-main">
                <Header />

                <section className="ttm-row zero-padding-section clearfix">
                    <div className="container-xl res-767-mt-0">
                        <section className="ttm-row service-section-style2 res-991-pb-0 ttm-bgcolor-grey clearfix">
                            <div className="row">
                                <div className="col-lg-7">
                                    <div className="spacing-10 ttm-bgcolor-grey ttm-bg ttm-col-bgcolor-yes ttm-right-span">
                                        <div className="ttm-col-wrapper-bg-layer ttm-bg-layer">
                                            <div className="ttm-bg-layer-inner" />
                                        </div>
                                        <div className="section-title with-desc clearfix">
                                            <div className="title-header">
                                                <h5>Send Message</h5>
                                                <h2 className="title">Drop Us A Line</h2>
                                            </div>
                                        </div>{/* section title end */}
                                        <form id="ttm-quote-form" className="row ttm-quote-form clearfix" method="post" action="#">
                                            <div className="col-sm-6 col-md-6">
                                                <div className="form-group">
                                                    <input name="UserMe" type="text" className="form-control bg-white" placeholder="User Me*" required="required" onChange={(e) => setUserMe(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-md-6">
                                                <div className="form-group">
                                                    <input name="UserTo" type="text" placeholder="User To*" required="required" className="form-control bg-white" onChange={(e) => setUserTo(e.target.value)} />
                                                </div>
                                            </div>

                                            <div className="col-sm-12 col-md-12">
                                                <div className="form-group">
                                                    <textarea name="Massage" rows={5} placeholder="Write A Massage..." required="required" className="form-control bg-white" defaultValue={""} onChange={(e) => setMsg(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="text-left">
                                                    <button type="button" onClick={() => sendMessage()} id="submit" className="mt-3 ttm-btn ttm-btn-size-md ttm-bgcolor-skincolor" value>
                                                        Kirim Pesan
                                                </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <div className="col-lg-5">
                                    <div className="spacing-9">
                                        <div className="section-title with-desc clearfix">
                                            <div className="title-header">
                                                <h5>Room Chat</h5>
                                                <h2 className="title">Single User</h2>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                {
                                                    chat.map((v, i) => {
                                                        return (
                                                            <div key={i} className="featured-icon-box style2 left-icon icon-align-top">
                                                                <div className="featured-icon">
                                                                    <div className="ttm-icon ttm-bgcolor-skincolor ttm-icon_element-size-md rounded-circle">
                                                                        <i className="ti-user" />
                                                                    </div>
                                                                </div>
                                                                <div className="featured-content">
                                                                    <div className="featured-title">
                                                                        <h5>{v.user}</h5>
                                                                    </div>
                                                                    <div className="featured-desc">
                                                                        <p>{v.message}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </section>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Tentang;